import React, { useState } from 'react';
import SimpleDialog from '../Atoms/SimpleDialog';
import ImageSelectionAndCropper from "../Organisms/ImageSelectionAndCropper";

interface IMomentCreateFilterDialog {
    open: boolean;
    onSubmit: Function;
    handleClose: Function;
}
const MomentCreateFilterDialog = ({ handleClose, onSubmit, open }: IMomentCreateFilterDialog) => {
    const [_, setTriggerSubmit] = useState(false);
    const handleOk = () => {
        setTriggerSubmit(true);
    };
    return (
        <SimpleDialog
            okButtonForm="Moments-Create-Filter"
            onCancel={handleClose}
            onOk={handleOk}
            open={open}
            title="Create filter"
        >
            <ImageSelectionAndCropper requiredType={'png'} aspectRatio={1} handleFileSelection={onSubmit} recommended={{width:1024, height:1024}}/>

        </SimpleDialog>
    );
};

export default MomentCreateFilterDialog;
